import { TextArea } from '@medenterprises/pulse-ui';
import React, { useId } from 'react';
import { Controller } from 'react-hook-form';
import type { Control, FieldErrors } from 'react-hook-form';
import type { FormText } from 'types/cms';

import usePulseFieldAttributes from './usePulseFieldAttributes';
import { fieldId, getFieldError, longTextRules } from './utils';

/**
 * A multi-line text input suitable for capturing larger data e.g a message in a contact form
 * @param control
 * @param identifier
 * @param label
 * @param max_length
 * @param required
 * @constructor
 */
const TextAreaLong = ({
  control,
  errors,
  identifier,
  label,
  max_length,
  required,
}: FormText & { control: Control; errors?: FieldErrors }) => {
  const errorMessage = getFieldError(errors, identifier);
  const containerRef = usePulseFieldAttributes('textarea', {
    id: fieldId(identifier, useId()),
    invalid: !!errorMessage,
    required: !!required,
    testId: identifier,
  });

  return (
    <Controller
      name={identifier}
      control={control}
      defaultValue=""
      // Pulse UI's TextArea doesn't forward `maxLength`, so the limit is enforced as a rule
      rules={longTextRules(required, max_length)}
      render={({ onChange, onBlur, value, name }) => (
        <div ref={containerRef}>
          <TextArea
            label={label}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            required={required}
            error={!!errorMessage}
            errorMessage={errorMessage}
          />
        </div>
      )}
    />
  );
};

export default TextAreaLong;
